import { jsx as _jsx } from "react/jsx-runtime";
import { Controller, useFormContext } from 'react-hook-form';
import { FormControl, } from '@tribeplatform/react-ui-kit/FormControl';
export function RadioGroup({ children, name, validation, ...rest }) {
    const { control } = useFormContext();
    return (_jsx(Controller, { control: control, name: name, rules: validation, defaultValue: "", render: ({ field: { onChange, value }, fieldState: { error } }) => (_jsx(FormControl.RadioGroup, { name: name, invalid: !!(error === null || error === void 0 ? void 0 : error.message), error: error === null || error === void 0 ? void 0 : error.message, value: value, onChange: value => {
                onChange(value);
            }, ...rest, children: children }, void 0)) }, void 0));
}
//# sourceMappingURL=Radio.js.map